var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',_vm._b({},'figure',_vm.attr,false),_vm._l((_vm.children),function(image,i){return _c('img',_vm._b({key:i,attrs:{"src":image['attr']['src']}},'img',image['attr'],false))}),0)}
var staticRenderFns = []

export { render, staticRenderFns }